// Route Preloader Service
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

class RoutePreloader {
  constructor() {
    this.routes = null;
    this.isLoading = false;
    this.hasLoaded = false;
    this.loadPromise = null;
  }

  async preloadRoutes() {
    // If already loading or loaded, return existing promise or data
    if (this.loadPromise) {
      return this.loadPromise;
    }

    if (this.hasLoaded) {
      return this.routes;
    }

    // Start loading
    this.isLoading = true;

    this.loadPromise = getDocs(collection(db, 'routes'))
      .then(routesSnap => {
        const routesData = routesSnap.docs.map(docSnap => ({
          ...docSnap.data(),
          id: docSnap.id,
        }));

        // Filter only routes that should be shown in store
        const visibleRoutes = routesData.filter(route =>
          route.storeStatus && route.storeStatus !== 'hidden'
        );

        // Sort routes: prioritize ready-to-use passes over coming soon
        visibleRoutes.sort((a, b) => {
          const isAAvailable = a.storeStatus === 'beta' || a.storeStatus === 'available';
          const isBAvailable = b.storeStatus === 'beta' || b.storeStatus === 'available';

          if (isAAvailable && !isBAvailable) return -1;
          if (!isAAvailable && isBAvailable) return 1;

          const dateA = a.submittedAt || a.updatedAt || { _seconds: 0 };
          const dateB = b.submittedAt || b.updatedAt || { _seconds: 0 };
          return (dateB._seconds || 0) - (dateA._seconds || 0);
        });

        // Preload all route images
        this.preloadImages(visibleRoutes);

        this.routes = visibleRoutes;
        this.hasLoaded = true;
        this.isLoading = false;

        return visibleRoutes;
      })
      .catch(error => {
        console.error('Error preloading routes:', error);
        this.isLoading = false;
        this.loadPromise = null;
        throw error;
      });

    return this.loadPromise;
  }

  preloadImages(routes) {
    // Preload all route cover images
    routes.forEach(route => {
      if (route.storeCoverImage) {
        const img = new Image();
        img.src = route.storeCoverImage;
      }
    });

    // Also preload common store page assets
    const storeAssets = [
      '/static/media/splashscreenlogo.*.png',  // Logo
    ];

    storeAssets.forEach(assetPath => {
      if (assetPath.includes('*')) {
        // Skip wildcards for now - these will be loaded with the bundle
        return;
      }
      const img = new Image();
      img.src = assetPath;
    });
  }

  getRoutes() {
    return this.routes;
  }

  clearCache() {
    this.routes = null;
    this.hasLoaded = false;
    this.loadPromise = null;
  }
}

// Create singleton instance
const routePreloader = new RoutePreloader();

export default routePreloader;